<script type="text/javascript">
	import LoadState from "../../Enums/LoadState"
	import Spinner from "../Spinner/Spinner.svelte"
	import SpinnerSize from "../Spinner/SpinnerSize"
</script>
<div>
	<p style="text-align:center;margin:100px;min-height:150px;overflow:auto;">
		<Spinner size={SpinnerSize.NORMAL} absolute={false} inline={true} />
	</p>
</div>
